import {MODAL_SHOW, MODAL_HIDE} from '../../../constants';

export const modal = {
    show: (content, title, buttons,jumpUrl) => {
        return {
            type: MODAL_SHOW,
            data: {
                content,
                title,
                buttons,
                jumpUrl
            }
        };
    },
    hide: () => {
        return {type: MODAL_HIDE};
    }
};
